import { IFeatureToggles } from '../../types/featureToggles';
import { axiosInstance } from '../axiosInstance';

export const getFeatureToggles = async (): Promise<IFeatureToggles> => {
  const response = await axiosInstance.get(`/feature-toggles`);
  return response.data;
};
